var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import * as S from "./FullScreenActivityIndicator.styles";
var FullScreenActivityIndicator = /** @class */ (function (_super) {
    __extends(FullScreenActivityIndicator, _super);
    function FullScreenActivityIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullScreenActivityIndicator.prototype.render = function () {
        return (_jsx(S.Wrap, { children: _jsx(S.ActivityIndicatorWrap, { transparent: this.props.transparent || false, children: _jsx(S.ActivityIndicatorStyled, {}) }) }));
    };
    return FullScreenActivityIndicator;
}(React.PureComponent));
export var renderWithFullScreenActivityIndicator = function (renderContent, isLoading) {
    return (_jsxs(_Fragment, { children: [renderContent(), isLoading && _jsx(FullScreenActivityIndicator, {})] }));
};
// eslint-disable-next-line import/no-default-export
export default FullScreenActivityIndicator;
